import React from 'react';
import PropTypes from 'prop-types';

import styles from './Divider.module.scss';

const Divider = ({ className, style }) => (
  <div style={style} className={[styles.divider, className].join(' ')} />
);

Divider.defaultProps = {
  className: '',
  style: {},
};

Divider.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

export default Divider;
